import { render } from "./UploadImage.vue?vue&type=template&id=e2662dfc&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"

import "./UploadImage.vue?vue&type=style&index=0&id=e2662dfc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e2662dfc"

export default script